import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";
import { connect } from "react-redux";

export interface GetOrdersApiParameterCustom extends GetOrdersApiParameter {
    customerNumber?: string;
}

const mapStateToProps = (state: ApplicationState) => ({
    currentBillTo: getBillToState(state, getSession(state).billToId).value,
    orderParameters: state.pages.orderHistory.getOrdersParameter as GetOrdersApiParameterCustom,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const orderNumberStyles: SearchTextFieldStyles = {};
const styles = orderNumberStyles;

const OrderHistorySearchLoadId: React.FunctionComponent<Props> = ({ currentBillTo, orderParameters }) => {
    const isWorEnable = currentBillTo?.properties?.isWOREnable?.toLowerCase() === "true";
    const currentBillCustomerNumber = currentBillTo?.customerNumber;
    const orderBillCustomerNumber = orderParameters?.customerNumber;
    const isSameBillCustomerOrder = currentBillCustomerNumber === orderBillCustomerNumber;

    if (isWorEnable && isSameBillCustomerOrder) {
        return (
            <SearchTextField
                styles={styles}
                parameterField={"loadId" as keyof GetOrdersApiParameter}
                label="Load #"
                inputType="text"
                placeholder=""
                testSelector="orderHistory_LoadNumber"
            />
        );
    }

    return null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderHistorySearchLoadId),
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "Load ID",
    },
};

export default widgetModule;
